<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid text-center" style="background-color: white;">
            <br>
            <h2 class="text-center p-3">เพิ่ม / แก้ไขข้อมูล ขนส่ง</h2>
            <br/>
            <!--data driver-->
            <div class="row">
                <div class="col-sm-6">
                    <!--upload name-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ชื่อขนส่ง
                        </label>
                        <div class="col-sm-8">
                            <input class="form-control"
                                   v-model="form.name"/>
                        </div>
                    </div>
                    <!--phone-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เบอร์โทร 1
                        </label>
                        <div class="col-sm-6">
                            <masked-input v-model="form.phone"
                                          mask="111-111-1111"
                                          placeholder=" เบอร์โทร 1"
                                          class="form-control"
                                          type="tel" />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เบอร์โทร 2
                        </label>
                        <div class="col-sm-6">
                            <masked-input v-model="form.phone2"
                                          mask="111-111-1111"
                                          placeholder=" เบอร์โทร 2"
                                          class="form-control"
                                          type="tel" />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เบอร์โทร 3
                        </label>
                        <div class="col-sm-6">
                            <masked-input v-model="form.phone3"
                                          mask="111-111-1111"
                                          placeholder=" เบอร์โทร 3"
                                          class="form-control"
                                          type="tel" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <!--upload address-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ที่อยู่
                        </label>
                        <div class="col-sm-8">
                            <input class="form-control"
                                   v-model="form.address"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4 col-form-label text-capitalize text-right">สายขนส่ง</div>
                        <div class="col-5">
                            <b-form-group>
                                <b-form-radio-group
                                        v-on:input="settingCost"
                                        id="radio-slots"
                                        v-model="form.transport_line_id"
                                        :options="options_road"
                                        name="radio-options-slots"
                                >
                                </b-form-radio-group>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ค่าขนส่งรถใหญ่
                        </label>
                        <div class="col-sm-8">
                            <input class="form-control"
                                   type="number"
                                   v-model="form.big_car_cost"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ค่าขนส่งรถบริษัท
                        </label>
                        <div class="col-sm-8">
                            <input class="form-control"
                                   type="number"
                                   v-model="form.company_car_cost"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ค่าขนส่งรถเล็ก
                        </label>
                        <div class="col-sm-8">
                            <input class="form-control"
                                   type="number"
                                   v-model="form.small_car_cost"/>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <!--button-->
            <div class="col text-center">
                <button @click="saveTransportationData"
                        type="button"
                        class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก
                </button>
                &nbsp&nbsp
                <button @click="goToTransportationList"
                        type="button"
                        class="btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon>
                    ยกเลิก
                </button>
            </div>
            <br/>
        </div>
        <!--<pre class="alert-success">{{form.phone.length}}</pre>-->
    </div>
</template>

<script>
    import HeaderTitle from "../../HeaderTitle";
    import {mapState} from "vuex";
    import Multiselect from "vue-multiselect";
    import MaskedInput from 'vue-masked-input'

    export default {
        components: {
            HeaderTitle,
            Multiselect,
            MaskedInput
        },
        name: "transportation-form",
        props: {
            id: {default: null}
        },
        data() {
            return {
                options_road : [
                    { text: 'พุทธมณฑล', value: 1 },
                    { text: 'ศาลายา', value: 2 },
                ],
                items: [
                    {
                        text: "รายการขนส่ง",
                        to: { name: "transportation" }
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],
                seen: false,
            }
        },
        created() {
            if (!this.id) {
                this.$store.dispatch('Transportation/clearForm')
            } else {
                this.$store.dispatch('Transportation/show', this.id)
            }
        },
        computed: {
            ...mapState({
                form: state => {
                    return state.Transportation.form
                }
            }),
        },
        methods: {
            saveTransportationData() {
                if (this.id) {
                    this.$store.dispatch('Transportation/save', {
                        id: this.id,
                        data: this.form
                    })
                        .then(() => {
                            this.goToTransportationList();
                        })
                } else {
                    this.$store.dispatch('Transportation/save', {
                        data: this.form
                    })
                        .then(() => {
                            this.goToTransportationList();
                        })
                }
            },
            goToTransportationList() {
                this.$router.push({name: "transportation"});
            },
            settingCost(){
                console.log(this.form.transport_line_id);
                if(this.form.transport_line_id == 1){
                    this.form.cost = 1000;
                }
                if(this.form.transport_line_id == 2){
                    this.form.cost = 1100;
                }
            },
        }
    }
</script>

<style scoped>

</style>